import { notification } from 'antd'
import { TFunction } from 'i18next'
import { UpdateInput } from '../../input/update-input'
import { CampaignSettingsFormValues, CustomAttributeRow } from './types'

export function customAttributeRows(attributes: Record<string, string>): CustomAttributeRow[] {
    return Object.entries(attributes).map(([key, value]) => ({ key, value }))
}

export function customAttributesFromRows(rows: CustomAttributeRow[] = []) {
    return rows.reduce<Record<string, string>>((carry, row) => {
        const key = row.key?.trim()

        if (!key) {
            return carry
        }

        carry[key] = row.value?.trim() ?? ''

        return carry
    }, {})
}

export function notifyCampaignUpdated(t: TFunction) {
    notification.success({
        message: t('{{name}} updated', { name: t('Campaign') }),
    })
}

function toTime(value: string) {
    return value.slice(0, 5)
}

// Converts the settings form values to the update request. Only the fields of the open panel are present.
export function toUpdateInput(values: CampaignSettingsFormValues): UpdateInput {
    const { customAttributeRows, ...input } = values

    return {
        ...input,
        ...('customAttributeRows' in values && { customAttributes: customAttributesFromRows(customAttributeRows) }),
        ...(input.recontactSchedule && {
            recontactSchedule: input.recontactSchedule.map((step, index) => ({
                ...step,
                delayMinutes: Number(step.delayMinutes),
                sortOrder: index,
            })),
        }),
        ...(input.recontactQuietHoursStart && { recontactQuietHoursStart: toTime(input.recontactQuietHoursStart) }),
        ...(input.recontactQuietHoursEnd && { recontactQuietHoursEnd: toTime(input.recontactQuietHoursEnd) }),
    }
}
